/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

/** Public read — used by BrandProvider at page load. */
export const getBrandSettings = async () =>
  (await api.get('/brand-settings')).data;

/** Admin write. Requires an admin cookie session. */
export const updateBrandSettings = async (payload) =>
  (await api.put('/admin/brand-settings', payload)).data;
